module.exports = __webpack_public_path__ + "static/media/2.0d1e8ab9.jpg";